








































































import dayjs from 'dayjs';
import { Component, Vue, Watch } from 'vue-property-decorator';
import authModule from '@/store/Auth';
import wordpressModule from '@/store/Wordpress';
import { OrganisationUser } from '@/api';
import { OrganisationUserRole } from '@/api/models/OrganisationUser';

@Component({})
export default class TermsAndConditionsDialog extends Vue {
  owners: OrganisationUser[] = [];

  loading = false;

  agree = false;

  showDialog = false;

  async getOwners() {
    if (!authModule.activeOrganisation) {
      return;
    }
    const owners = (
      await OrganisationUser.includes('user')
        .where({
          organisation: authModule.activeOrganisation.organisation.id,
          role: OrganisationUserRole.Owner,
        })
        .all()
    ).data;
    this.owners = owners;
  }

  setShowDialog() {
    this.showDialog =
      !!this.latestTerms && (this.requireUserAgree || this.accessLocked);
  }

  get user() {
    return authModule.user;
  }

  get latestTermsDate() {
    return this.latestTerms ? dayjs(this.latestTerms.date) : null;
  }

  get isUserAgree() {
    if (!this.user || !this.latestTermsDate) {
      return false;
    }
    return (
      this.user.agreeTcAt && this.latestTermsDate.isBefore(this.user.agreeTcAt)
    );
  }

  get latestTerms() {
    return wordpressModule.latestTerms;
  }

  get requireUserAgree() {
    // training session does not require user agreement
    if (authModule.isTrainingSession) {
      return false;
    }
    return !!this.latestTerms && !this.isUserAgree;
  }

  get isGracePeriod() {
    return wordpressModule.isGracePeriod;
  }

  get gracePeriodEnd() {
    return wordpressModule.gracePeriodEnd;
  }

  get hasAgreement() {
    return this.owners.some((ou: OrganisationUser) => {
      if (!this.latestTermsDate) {
        return true;
      }

      const { user } = ou;
      return (
        !!user.agreeTcAt && dayjs(user.agreeTcAt).isAfter(this.latestTermsDate)
      );
    });
  }

  get accessLocked() {
    // access lock does not apply to owner or training session
    if (
      !this.user ||
      !authModule.activeOrganisation ||
      authModule.isOwner ||
      authModule.isTrainingSession
    ) {
      return false;
    }

    // show access lock if owner has not agreed to terms and grace period is over
    return (
      !!this.latestTermsDate &&
      !!this.gracePeriodEnd &&
      !this.isGracePeriod &&
      !this.hasAgreement
    );
  }

  logout() {
    authModule.logout();
  }

  dialogContent(post: WordpressPost) {
    if (!post) {
      return '';
    }

    let content = '';
    content = post.content.rendered;

    return content;
  }

  async agreeTermsAndConditions() {
    if (!this.user) {
      return;
    }
    this.user.agreeTcAt = dayjs().toISOString();
    await this.user.save();
    this.showDialog = false;
  }

  @Watch('showDialog')
  showDialogChanged(val: boolean) {
    if (!val) {
      this.$emit('dismiss', 'terms');
    }
  }

  async beforeMount() {
    await this.getOwners();
    this.setShowDialog();
    if (!this.showDialog) {
      this.$emit('dismiss', 'terms');
    }
  }
}
